import { obtenerExtrasAceptadasAction } from "./../../../ducks/extrasContratadosAceptadasDuck"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import TExtras from "./TExtras"

const VExtras = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerExtrasAceptadasAction())
    },[])
    return (
        <div>
            <TExtras />
        </div>
    )
}
export default VExtras